// Vendor JS
import Debug from 'debug';

// Custom JS
import AvatarUploader from '../common/avatar-uploader';

/**
 * Fired on /profile page (allows users to change display name and avatar)
 */
export default {
	init() {
		try {
			Debug(`cig:info:sage:route:profile`)(`init start`);

			// Setup FilePond for avatar uploading
			AvatarUploader.init();

		} catch (err) {
			Debug(`cig:error:sage:route:profile`)(`Profile Route init Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	},

	// Fires after init
	finalize() {
		try {
			Debug(`cig:info:sage:route:profile`)(`finalize start`);

		} catch (err) {
			Debug(`cig:error:sage:route:profile`)(`Profile Route finalize Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	},
};
